import { createAction } from '/@/store/utils';

export const setIncreaseCount = createAction('LOADING_COUNT:SET_INCREASE_COUNT');
export const setResetCount = createAction('LOADING_COUNT:SET_RESET_COUNT');
export const setTotalCount = createAction('LOADING_COUNT:SET_TOTAL_COUNT');
